import { config } from "../system/Config";

export const errorImgUrl = `https://storage.googleapis.com/locambio-dev/system/error.png`;